// Libraries
import {
  NgModule,
  ModuleWithProviders,
  InjectionToken
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Positioning } from 'positioning';

// Components
import { ConfirmationPopoverWindowComponent } from './confirmation-popover-window.component';

// Directives
import { ConfirmationPopoverDirective } from './confirmation-popover.directive';
import { FocusDirective } from './focus.directive';

// Options
import {
  ConfirmationPopoverOptions,
  ConfirmationPopoverOptionsInterface
} from './confirmation-popover-options.provider';

// User options
export const USER_OPTIONS: InjectionToken<string> = new InjectionToken('confirmation popover user options');
// Options factory
export function optionsFactory(userOptions: ConfirmationPopoverOptions): ConfirmationPopoverOptions {
  const options: ConfirmationPopoverOptions = new ConfirmationPopoverOptions();
  Object.assign(options, userOptions);
  return options;
}

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ConfirmationPopoverWindowComponent,
    ConfirmationPopoverDirective,
    FocusDirective
  ],
  exports: [
    ConfirmationPopoverDirective,
    FocusDirective
  ],
  entryComponents: [
    ConfirmationPopoverWindowComponent
  ]
})
export class ConfirmationPopoverModule {
  static forRoot(options: ConfirmationPopoverOptionsInterface = {}): ModuleWithProviders {
    return {
      ngModule: ConfirmationPopoverModule,
      providers: [{
        provide: USER_OPTIONS,
        useValue: options
      }, {
        provide: ConfirmationPopoverOptions,
        useFactory: optionsFactory,
        deps: [USER_OPTIONS]
      }, Positioning]
    };
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/confirmation-popover/confirmation-popover.module.ts